/** 工资结算路由 */
export default {
    name: 'salary',
    path: 'salary',
    meta: {
        title: '工资结算'
    },
    component: ()=>import('@/pages/salary/salary.vue'),
    children: []
}